export default {
  __name: 'App',
  setup: function setup(__props) {
    return {
      __sfc: true
    };
  }
};